define.alias("shared/components/shared/post/profile-selector/profile-list", "settings/components/shared/post/profile-selector/profile-list/index");